import { render } from "./CookiesDescriptionBox.vue?vue&type=template&id=7ba30de7&scoped=true&ts=true"
import script from "./CookiesDescriptionBox.vue?vue&type=script&lang=ts"
export * from "./CookiesDescriptionBox.vue?vue&type=script&lang=ts"

import "./CookiesDescriptionBox.vue?vue&type=style&index=0&id=7ba30de7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba30de7"]])

export default __exports__